import React from 'react';
import {Container, Col, Row} from "react-bootstrap";
import './ourServices.css'

import SecondaryCustomButton from "../accesories/customBtn/SecondaryCustomButton";
import IconCart from "../accesories/carts/IconCart";

function OurServices({items=[]}) {
    const colors = ['rgb(255, 239, 248)', 'rgb(255, 246, 212)', 'rgb(211, 246, 254)', 'rgb(211, 246, 254)', 'rgb(208, 250, 236)','rgb(255, 246, 212)']
    return (
        <Container className={'our-services-container'}>
            <Row className="our-services-up-row mb-5">
                <h3>خدمات <span>ما</span></h3>
                <div className={'horizontal-line'}/>
            </Row>
            <Row className={'mt-3 our-services-bottom-row'}>
                <Col>
                    <Row>
                        {
                            items.map((item, index) => (
                                <IconCart key={item.id} lg={4} md={6} color={colors[index]} icon={`flaticon-${item.icon}`}
                                          header={item.title}
                                          content={item.description}/>
                            ))
                        }

                    </Row>
                </Col>
            </Row>

        </Container>
    );
}

export default OurServices;